import React, { useState,useEffect,useRef } from "react";
import {Text, TouchableOpacity, View, FlatList, Animated } from "react-native";
import CText from "./CText";
import CImage from "./CImage";
import { CreateResponsiveStyle, DEVICE_SIZES} from "rn-responsive-styles";
import { COLORS, FONTS } from "../constant";
import applicationStyles from "../styles/applicationStyles";
import { random } from "lodash";


const CDropdown = ({ props,label, value, items, onSelect, mandatoryField,customStyle,disable }) => {
  const styles = useStyles();
  const menuRef = useRef(null);
  const buttonRef = useRef(null);
  const [isOpen, setOpen] = useState(false)
  const toggleDropdown = () => setOpen(!isOpen);
  let displayValue = "Select";
  const selectedItem = items?.find(x => x.value === value);
  if (selectedItem) {
    displayValue = selectedItem.label;
  }
  const handleOutsideClick = (event) => {
    if (
      menuRef.current &&
      !menuRef.current.contains(event.target) &&
      event.target !== buttonRef.current
    ) {
      setOpen(false);
    }
  };
 
  useEffect(() => {
    document.addEventListener('mousedown', handleOutsideClick);
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, []);

  return (
    <View style={styles.inputWrapper}>
      <CText.inputTopLabel>
        {label}
         {
            mandatoryField
            ? <Animated.Text
            style={[
              styles.inlineError,
              { color: "#f00", fontSize: 15, fontWeight: "500" },
            ]}
          >
            {" *"}
          </Animated.Text>
          : null
          }
        </CText.inputTopLabel>
      <View style={[styles.dropDownViewStyle,customStyle]} ref = {menuRef}>
        <TouchableOpacity
          onPress={ disable ? ()=>{} : toggleDropdown}
          style={isOpen ? styles.dropdownHeader : styles.dropdownHeaderHide}
          ref={buttonRef}
        >
          <Text style={applicationStyles.dropDownHeaderText}>
          { props?.lengthValue != "" ? ((displayValue).length > 25)  ? 
             (((displayValue).substring(0,25)) + '...') : 
          displayValue : ((displayValue).length > 15)  ? 
             (((displayValue).substring(0,15)) + '...') : 
                    displayValue }

          </Text>
          <CImage.dropdownArrowIcon style={applicationStyles.iconDropdown} />
        </TouchableOpacity>
       
        <View  style={isOpen ? [styles.showDropdown,customStyle, {zIndex:99 }]  : styles.hideDropdown}>
          <View>
          <FlatList 
              style={{height:150}}
              data={items}
              key={random()}
              showsVerticalScrollIndicator = {true}
              keyExtractor={(item) => item.label}
              renderItem={({item}) => {
                return(
                <TouchableOpacity
                  onPress={(e) => {
                    onSelect(item.value)
                    toggleDropdown()
                  }
                  }
                  style={applicationStyles.listItems}
                >
                  <Text style={applicationStyles.listItem}>{`${item.label} `}</Text>
                </TouchableOpacity>
                )
              }}
          />
          </View>
          </View>
      </View>
    </View>
  );
}

const useStyles = CreateResponsiveStyle(
  {

    dropDownViewStyle: {
      width: 230,
      height: 36.5,
      borderRadius: 8.3,
      position: "relative",
      backgroundColor: "rgba(0, 0, 0, 0)",
      borderStyle: "solid",
      borderWidth: 2,
      borderColor: COLORS.white1,
      fontFamily: FONTS.InterMedium,
      fontSize: 16,
      lineHeight: 18,
      letterSpacing: 0.1,
      textAlign: "left",
      color: COLORS.darkBlack,
      zIndex:999
    },
    inlineError: {
      fontFamily: "Inter",
      fontSize: 12,
      color: "#db1a1a",
      marginTop: 3,
      marginLeft: 0,
    },
    dropdownHeader: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      padding: 10,
    },
    dropdownHeaderHide: {
      flexDirection: "row",
      alignItems: "center",
      justifyContent: "space-between",
      width: "100%",
      position: "relative",
      padding: 10,
    },
    showDropdown: {
      display: "flex",
      border: "2px solid #dfdfdf",
      width: 230,
      position: "absolute",
      top: 34,
      backgroundColor: "#fff",
      borderBottomLeftRadius: 12,
      borderBottomRightRadius: 12,
      boxShadow: "0 11px 11px 0 rgba(0, 0, 0, 0.16)",
      zIndex:999,
      height:150,
      flexGrow:1
    },

    hideDropdown: { display: "none" },

    inputWrapper: {
      gap: 10,
    },
  },
  {
    [DEVICE_SIZES.LG]: {},
    [DEVICE_SIZES.MD]: {},
    [DEVICE_SIZES.SM]: {},
    [DEVICE_SIZES.XS]: {
        dropDownViewStyle:{
            width :230 
        },
        showDropdown:{
            width : 264     
        }

    },
  }
);

export default CDropdown;
